import { Height } from "@mui/icons-material";
import { DataExam } from "../../Utils/DataExample"
import { useSelector } from "react-redux";
import { RootState } from "../../redux";
import LockPage from "../../components/LockPage";
import { profile } from "console";
import { ProfileStudent } from "../../Utils/DataType";

export default function Exam() {
    let auth = useSelector<RootState, boolean>(state => state.auth);
    let profile = useSelector<RootState, ProfileStudent>(state => state.profile);
    let dataExam = DataExam;
    return (
        <div className="exam-page">
            <div className="page-main-veritcal" style={{ height: '100%' }}>
                <div className="page-title home-title w-6/6">Xem lịch thi</div>
                {auth && (
                    <>
                        <div className="mt-4">
                            <div className="mt-2"><span className="font-bold">Sinh viên: </span> <span className="text-[#1565c0]">{`${profile.first_name} ${profile.last_name}`}</span></div>
                            <div className="mt-2"><span className="font-bold">Mã số sinh viên: </span><span className="text-[#1565c0]">{profile.student_id}</span></div>
                            <div className="mt-2"><span className="font-bold">Quê quán: </span><span className="text-[#1565c0]">{profile.address.split('-').reverse().join(' - ')}</span></div>
                        </div>
                        <div className="table-exam mt-4">
                            <table>
                                <thead>
                                    <tr>
                                        <th>STT</th>
                                        <th>Mã MH</th>
                                        <th>Tên môn học</th>
                                        <th>Sĩ số</th>
                                        <th>Ngày thi</th>
                                        <th>Giờ bắt đầu</th>
                                        <th>Phút</th>
                                        <th>Phòng thi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dataExam.map((item, index) => {
                                        return (
                                            <tr>
                                                <td className="text-center">{index + 1}</td>
                                                <td className="text-center">{item.ma_mon}</td>
                                                <td>{item.ten_mon}</td>
                                                <td className="text-center">{item.si_so}</td>
                                                <td className="text-center">{item.ngay_thi}</td>
                                                <td className="text-center">{item.gio_bat_dau}</td>
                                                <td className="text-center">{item.so_phut}</td>
                                                <td className="text-center">{item.ma_phong}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
                {!auth && <LockPage />}
            </div>
        </div>
    )
}